import Vue from "vue";
import { reflectKeys, jwt, appLocalStorage } from '@/app/shared/services';

import { fetchGuide, fetchTags, fetchArtefacts, fetchArtefact, fetchArtefactUnit, fetchMock } from '../services';

/** Initial state */
const initialState = {
  loading: false,
  data: null,
  error: null,
  guide: [],
  tags: [],
  artefacts: [],
  artefact: {},
  artefactUnit: {}
};

/** Prefix for mutation types and actiontypes */
const namespacedPrefix = '[SENSER]';

/**
 * Mutation types
 */
const mutationTypes = reflectKeys(
  [
    'SENSER_DATA_REQUEST',
    'SENSER_DATA_SUCCESS',
    'SENSER_DATA_ERROR',
    'SENSER_DATA_RESET',
    'LOOKUP_SENSER_GUIDE',
    'SET_SENSER_GUIDE',
    'SET_SENSER_GUIDE_ON',
    'LOOKUP_SENSER_TAGS',
    'SET_SENSER_TAGS',
    'LOOKUP_SENSER_ARTEFACTS',
    'SET_SENSER_ARTEFACTS',
    'LOOKUP_SENSER_ARTEFACT',
    'SET_SENSER_ARTEFACT',
    'LOOKUP_SENSER_ARTEFACT_UNIT',
    'SET_SENSER_ARTEFACT_UNIT',
    'RESET_SENSER'
  ],
  namespacedPrefix
);

const {
  SENSER_DATA_REQUEST,
  SENSER_DATA_SUCCESS,
  SENSER_DATA_ERROR,
  SENSER_DATA_RESET,
  LOOKUP_SENSER_GUIDE,
  SET_SENSER_GUIDE,
  SET_SENSER_GUIDE_ON,
  LOOKUP_SENSER_TAGS,
  SET_SENSER_TAGS,
  LOOKUP_SENSER_ARTEFACTS,
  SET_SENSER_ARTEFACTS,
  LOOKUP_SENSER_ARTEFACT,
  SET_SENSER_ARTEFACT,
  LOOKUP_SENSER_ARTEFACT_UNIT,
  SET_SENSER_ARTEFACT_UNIT,
  RESET_SENSER
} = mutationTypes;

/**
 * Auth data mutations
 */
const mutations = {
  /** auth data request */
  [SENSER_DATA_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },

  /** auth data success */
  [SENSER_DATA_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload, user: payload, isAuthenticated: true });
  },

  /** auth data error */
  [SENSER_DATA_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true
    });
  },

  /** reset auth data */
  [SENSER_DATA_RESET](state) {
    Object.assign(state, initialState);
  },

  [LOOKUP_SENSER_GUIDE](state) {
    state.loading = true;
  },
  [SET_SENSER_GUIDE](state, payload) {
      state.guide = payload.res.data;
      state.loading = false;
  },
  [SET_SENSER_GUIDE_ON](state, guide) {
      state.guideOn = guide;
      state.loading = false;
  },
  [LOOKUP_SENSER_TAGS](state) {
      state.loading = true;
  },
  [SET_SENSER_TAGS](state, payload) {
      state.tags = payload.res.data;
      state.tagsCount = payload.res.data ? payload.res.data.length : 0;
      state.loading = false;
  },
  [LOOKUP_SENSER_ARTEFACTS](state) {
      state.loading = true;
  },
  [SET_SENSER_ARTEFACTS](state, payload) {
      state.artefacts = payload.artefacts;
      state.artefactsCount = payload.artefacts ? payload.artefacts.length : 0;
      state.loading = false;
  },
  [LOOKUP_SENSER_ARTEFACT](state) {
      state.loading = true;
  },
  [SET_SENSER_ARTEFACT](state, payload) {
    //   state.artefact = payload;
    //   state.artefact = Object.assign({}, state.artefact, payload)
    state.artefact = {};
    state.artefact = payload;
      state.loading = false;
  },
  [LOOKUP_SENSER_ARTEFACT_UNIT](state) {
      state.loading = true;
  },
  [SET_SENSER_ARTEFACT_UNIT](state, payload) {
    state.artefactUnit = payload;
    state.loading = false;
  },
  [RESET_SENSER](state) {
      for (let f in state) {
          Vue.set(state, f, state.initialState[f]);
      }
  }

};

/** Actions types constants */
export const actionsTypes = reflectKeys([
  'FETCH_SENSER_GUIDE',
  'FETCH_SENSER_TAGS',
  'FETCH_SENSER_ARTEFACTS',
  'FETCH_SENSER_ARTEFACT',
  'FETCH_SENSER_ARTEFACT_UNIT',
  'RESET_SENSER_STATE'
], namespacedPrefix);

/**
 * Users data actions
 */
const actions = {

  async [actionsTypes.FETCH_SENSER_GUIDE](context, payload) {
    context.commit(LOOKUP_SENSER_GUIDE);
    return await fetchGuide(payload)
        .then(data => {
            payload.res = data;
            context.commit(SET_SENSER_GUIDE, payload);
        })
        .catch(error => {
            payload.res = error;
            context.commit(SET_SENSER_GUIDE, payload);
        });
  },
  async [actionsTypes.FETCH_SENSER_TAGS]({ commit }, payload) {
      commit(LOOKUP_SENSER_TAGS);
      return await fetchTags(payload)
          .then(data => {
              payload.res = data;
              commit(SET_SENSER_TAGS, payload);
          })
          .catch(error => {
              payload.res = error;
              commit(SET_SENSER_TAGS, payload);
          });
  },
  async [actionsTypes.FETCH_SENSER_ARTEFACTS]({ commit }, payload) {
      commit(LOOKUP_SENSER_ARTEFACTS);
      return await fetchArtefacts(payload)
          .then(data => {
              payload.res = data;
              commit(SET_SENSER_ARTEFACTS, payload);
          })
          .catch(error => {
              payload.res = error;
              commit(SET_SENSER_ARTEFACTS, payload);
          });
  },
  async [actionsTypes.FETCH_SENSER_ARTEFACT](context, payload, prevArtifact) {
    // avoid extronuous network call if search exists
    context.commit(LOOKUP_SENSER_ARTEFACT);
    if (prevArtifact !== undefined) {
        return context.commit(SET_SENSER_ARTEFACT, prevArtifact);
    }

    // let payloadNew = Object.assign(payload, {});
    // payloadNew.type = 'SCDF' 

    const promise1 = fetchMock(payload);
    const promise2 = fetchArtefact(payload);

    return await Promise.all([promise1, promise2])
      .then(values => {
        // console.log(values);
        let mock = {};
        try{
          payload.mock = JSON.parse(JSON.stringify(values[0].data));
        } catch(e){
          console.log(e);
        }
        let data = values[1];
        payload.res = data.data;
        context.commit(SET_SENSER_ARTEFACT, payload);
      })
      .catch(error => {
        payload.mock = {error: 'No Mock records found for the search criteria.'};
        payload.res = {error: 'No records found for the search criteria.'};
        context.commit(SET_SENSER_ARTEFACT, payload);
        // throw new Error(error);
      });
  },
  async [actionsTypes.FETCH_SENSER_ARTEFACT_UNIT](context, payload, prevArtifact) {
      // avoid extronuous network call if search exists
      context.commit(LOOKUP_SENSER_ARTEFACT_UNIT);
      if (prevArtifact !== undefined) {
          return context.commit(SET_SENSER_ARTEFACT_UNIT, prevArtifact);
      }
      return await fetchArtefactUnit(payload)
          .then(data => {
              payload.res = data.data;
              context.commit(SET_SENSER_ARTEFACT_UNIT, payload);
          })
          .catch(error => {
            payload.res = {error: 'No records found for the given criteria.'};
              context.commit(SET_SENSER_ARTEFACT_UNIT, payload);
          });
  },
  [actionsTypes.RESET_SENSER_STATE]({ commit }) {
      commit(RESET_SENSER);
  } 
};

/**
 * Users data actions
 */
const state = {
  ...initialState,
  guideOn: [],
  tagsCount: 0,
  artefactsCount: 0
};

const getters = {
  isLoading( state ) {
    return state.loading;
  },
  tagsCount( state ) {
      return state.tagsCount;
  },
  tags( state ) {
      return state.tags;
  },
  artefactsCount( state ) {
      return state.artefactsCount;
  },
  artefacts( state ) {
      return state.artefacts;
  },
  artefact( state ) {
      return state.artefact;
  },
  artefactUnit( state ) {
      return state.artefactUnit;
  },
  guide( state ) {
      return state.guide;
  },
  guideOn( state ) {
      return state.guideOn;
  }
};

export default {
  mutations,
  actions,
  state,
  getters
};
